import { Enums } from '../../../../models/common'
import { OpAlarmDefGroup } from '../../../../models/core'
import { LocalizationHelper, TypeHelper } from '../../../../helpers'
import { UserSessionService } from '../../../../services/user-session'
import { AlarmDefinitionGroupOptions } from './alarm-definition-group-row.interfaces'

export class AlarmDefinitionGroupRowController
    implements ng.IComponentController
{
    // #region Consts

    public get NO_DATA_TO_DISPLAY_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoAssignedAlarmGroups) }

    // #endregion

    // #region Members

    public options: AlarmDefinitionGroupOptions

    // #endregion

    // #region Ctor

    constructor(
        private userSessionService: UserSessionService
    ) {
    }

    // #endregion

    // #region ng.IComponentController implementation

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

     // #endregion

    // #region Setup

    private initialize(): void {
        this.onInitialized()
    }

    // #endregion

    // #region Events

    private onInitialized(): void {

    }

    // #endregion

    // #region AlarmDefinitionGroupRowController

    public getAlarmGroupDescription(group: OpAlarmDefGroup): string {
        return group == null || group.alarmGroup == null
            ? TypeHelper.emptyString
            : group.alarmGroup.toString()
    }

    public getTransmissionTypeDescription(group: OpAlarmDefGroup): string {
        if (group == null) {
            return TypeHelper.emptyString
        }

        switch (group.idTransmissionType) {
            //case Enums.TransmissionType.Binary: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Binary)
            case Enums.TransmissionType.Text: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Sms)
            //case Enums.TransmissionType.Text7bit: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Sms7Bit)
            //case Enums.TransmissionType.PDUBinary: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PDUBinary)
            case Enums.TransmissionType.EMail: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Email)
            //case Enums.TransmissionType.Ring: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Ring)
            //case Enums.TransmissionType.WebService: return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WebService)
            default: return TypeHelper.emptyString
        }
    }

    public hasItems(): boolean {
        return this.options != null && this.options.alarmDefGroups != null && this.options.alarmDefGroups.length > 0
    }

    // #endregion
}
